<template>
  <div id="order-amount">
    <el-row>
      <span>下单日期:</span>
      <el-date-picker
        v-model="searchDate"
        align="right"
        type="date"
        placeholder="选择日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button @click="refresh" type="primary">刷新</el-button>
    </el-row>
    <el-row style="margin:20px">
      <span>
        总共:{{total}} 正常:{{normalCount}}
        <span style="color:red">删除:{{deleteCount}}</span>
      </span>
    </el-row>
    <!-- 列表 -->
    <el-table :data="tableData" border v-loading="listLoading" :row-class-name="tableRowClassName">
      <el-table-column prop="order" label="订单号" width="148px"></el-table-column>
      <el-table-column prop="status" label="订单状态" width="148px"></el-table-column>
      <el-table-column prop="material" label="材料" width="200px"></el-table-column>
      <el-table-column prop="style" label="规格"></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      searchDate: "",
      listLoading: false,
      tableData: [],

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "前天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", date);
            }
          }
        ]
      },

      total: 0,
      normalCount: 0,
      deleteCount: 0
    };
  },
  watch: {
    searchDate: function(val) {
      this.findByDate();
    }
  },
  //   created(){
  //       this.searchDate = new Date();
  //   },
  methods: {
    refresh() {
      if (this.searchDate == "") {
        this.$message.error("请选择时间");
        return;
      }
      this.findByDate();
      this.$message.success("刷新成功");
    },
    findByDate: async function() {
      if (this.searchDate == "") {
        this.$message.error("请选择时间");
        return;
      }
      let postBody = {
        crud: "r",
        info: {
          key: this.searchDate
        }
      };
      this.listLoading = true;
      let response = await this.$doPost("/api/report/orderamount", postBody);
      if (response.msgCode == 0) {
        this.tableData = response.result.infos;
        this.total = this.tableData.length;
        this.normalCount = 0;
        this.deleteCount = 0;
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].status == 88) {
            this.tableData[i].status = "删除";
            this.deleteCount++;
          } else {
            this.tableData[i].status = "正常";
            this.normalCount++;
          }
        }
      } else {
        this.$message.error(this.response.msg);
      }
      this.listLoading = false;
    },
    tableRowClassName(val) {
      if (val.row.status == "删除") {
        return "isdelete";
      } else {
        return "";
      }
    }
  }
};
</script>
<style>
.isdelete {
  background: #ffaeb9 !important;
  /* color: white !important; */
}
</style>





// WEBPACK FOOTER //
// src/components/report/OrderAmount.vue